import {omit} from "@Common/utils/objects";

export const createNonceCard = (card, btTokenResult) => ({
    ...omit(card, ["stateProvince"]),
    state: card["stateProvince"],
    braintreeNonce: btTokenResult.nonce,
    "cardType": btTokenResult.details.cardType,
    "cardBin": btTokenResult.details.bin,
    "cardExpirationMonth": btTokenResult.details.expirationMonth,
    "cardExpirationYear": btTokenResult.details.expirationYear,
    "expiration": `${btTokenResult.details.expirationMonth}/${btTokenResult.details.expirationYear}`,
    "cardNumber": `${btTokenResult.details.bin}******${btTokenResult.details.lastFour}`,
    "cardLast4": btTokenResult.details.lastFour,
});

